export default "__VITE_ASSET__BE30VDHe__"